/**
 * Used to regulate the MessageBar's background color and default icon
 */
export var MessageCardSeverity;
(function (MessageCardSeverity) {
    MessageCardSeverity["Info"] = "Info";
    MessageCardSeverity["Warning"] = "Warning";
    MessageCardSeverity["Error"] = "Error";
})(MessageCardSeverity || (MessageCardSeverity = {}));
